export default __webpack_public_path__ + "static/media/eliminate.f6dc2aed.svg";